<template>
    <div>
        <div style="background-color: white; text-align: center">
            <h4>พิมพ์รายงานการขาย</h4>
            <br>
            <div class="row form-group">
                <label class="col-sm-4 text-right">เลือกช่วงที่ต้องการพิมพ์</label>
                <div class="col-sm-6">
                    <b-form-select :options="print_date"
                                   v-model="print.range">
                    </b-form-select>
                </div>
            </div>
            <div class="row form-group" v-if="print.range == 1">
                <label class="col-sm-4 text-right">พิมพ์รายงาน/วัน</label>
                <div class="col-sm-6">
                    <date-picker v-model="print.date"
                                 :lang="lang"
                                 placeholder="วันที่ต้องการพิมพ์"
                                 format="DD/MM/YYYY" confirm>
                    </date-picker>
                </div>
            </div>
            <div class="row form-group" v-if="print.range == 2">
                <label class="col-sm-4 text-right">พิมพ์รายงาน/เดือน</label>
                <div class="col-sm-6">
                    <date-picker v-model="print.date"
                                 type="month"
                                 :lang="lang"
                                 placeholder="เดือนต้องการพิมพ์"
                                 format="MM/YYYY" confirm>
                    </date-picker>
                </div>
            </div>
            <div class="row form-group" v-if="print.range == 3">
                <label class="col-sm-4 text-right">พิมพ์รายงาน/ปี</label>
                <div class="col-sm-6">
                    <date-picker v-model="print.date"
                                 type="year"
                                 :lang="lang"
                                 placeholder="เดือนต้องการพิมพ์"
                                 format="YYYY" confirm>
                    </date-picker>
                </div>
            </div>
            <button @click="submitInvoiceReport"
                    type="button"
                    class="btn btn-primary">
                <icon name="print"></icon>
                พิมพ์
            </button>
            &nbsp;&nbsp;
            <button @click="cancelInvoiceReport"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
        name: "print-report-invoice-modal",
        components:{
            DatePicker,
        },
        data(){
            return{
                print : {
                    range : null,
                    date : "",
                },
                print_date : [
                    {value: null,text:"ช่วง วัน - เดือน - ปี"},
                    {value: 1,text:"เลือกพิมพ์วัน"},
                    {value: 2,text:"เลือกพิมพ์เดือน"},
                    {value: 3,text:"เลือกพิมพ์ปี"},
                ],
                changeFormat: {
                    stringify: (date) => {
                        if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        methods:{
            submitInvoiceReport(){
                let data = {
                    date : "",
                    month : "",
                    year : ""
                };
                if(!this.print.date){
                    alert("กรุณาเลือก วัน - เดือน -ปี")
                }
                else{
                    if(this.print.range == 1){ //date
                        data.date = moment(this.print.date).format("YYYY-MM-DD");
                    }
                    if(this.print.range == 2){ //date
                        data.month = moment(this.print.date).format("MM");
                        data.year = moment(this.print.date).format("YYYY");
                    }
                    if(this.print.range == 3){ //date
                        data.year = moment(this.print.date).format("YYYY");
                    }
                    this.$emit("submit",data);
                    this.clearInvoiceReport();
                }
            },
            cancelInvoiceReport(){
                this.$emit("submit",false);
                this.clearInvoiceReport();
            },
            clearInvoiceReport(){
                this.print = {
                    date : "",
                    range : null
                }
            }
        }
    }
</script>

<style scoped>

</style>
